import { createContext } from "react";
import { Stage } from "../lusca-search-api/generated-src";

const OrderIdContext = createContext("");

const StageContext = createContext<Stage>(null as never);

/** Alias of the Dev stack being viewed; undefined means the signed-in user's own. */
const DevUserContext = createContext<string | undefined>(undefined);

export { DevUserContext, OrderIdContext, StageContext };
